import styled from 'styled-components';
import Checkbox from '@nubank/nuds-web/components/Checkbox/Checkbox';

export const StyledCheckbox = styled(Checkbox)`
  margin-bottom: 2rem;
  width: 22rem ;
  padding: 0;
`;
StyledCheckbox.displayName = 'StyledCheckbox';
